window.addEventListener('DOMContentLoaded', function () {

    let floatingMenu = document.querySelector('.floating__side-bar');
    if( !floatingMenu ) return; // Exit if floating menu is not present



    
   

    function alignFloatingMenuToHeader() {
        const header = document.querySelector('header .header__row');
        const floatingMenu = document.querySelector('.floating__side-bar');
    
        if (floatingMenu && header) {
            const headerStyles = getComputedStyle(header);
            const paddingLeft = parseFloat(headerStyles.paddingLeft);
            const paddingRight = parseFloat(headerStyles.paddingRight);
            const headerWidth = header.offsetWidth - paddingLeft - paddingRight;
    
            floatingMenu.style.left = `calc(50% - ${headerWidth / 2}px + ${paddingLeft}px)`;
        }

        floatingMenu.style.display = 'flex';


    }


    let menuItems = floatingMenu.querySelectorAll('.floating__side-bar-menu-item');
    let menuIcons = floatingMenu.querySelectorAll('.floating__side-bar--menu-open-icon'); 

    menuIcons.forEach((icon, index) => {
        const toggleMenu = () => {
            // Remove 'active' class from all menu items and icons
            menuItems.forEach(item => item.classList.remove('active'));
            menuIcons.forEach(i => i.classList.remove('active'));
    
            // Toggle active class for the hovered/clicked icon and menu item
            menuItems[index].classList.toggle('active');
            icon.classList.toggle('active');
        };
    
        // Add both click and mouseover handlers
        icon.addEventListener('click', toggleMenu);
        icon.addEventListener('mouseenter', toggleMenu);
    });
    

    

    // Close menu on clicking outside
    document.addEventListener('click', function(event) {
        if (!floatingMenu.contains(event.target)) {
            menuItems.forEach(item => item.classList.remove('active'));
            menuIcons.forEach(i => i.classList.remove('active'));
        }
    });

    // close btn close__icon 
    let closeBtns = floatingMenu.querySelectorAll('.close__icon');
    closeBtns.forEach((btn, index) => {
        btn.addEventListener('click', function() {
            menuItems[index].classList.remove('active');
            menuIcons[index].classList.remove('active');
        });
    });

    // .scroll-top
    let scrollTopBtn = floatingMenu.querySelector('.scroll-top');
    scrollTopBtn && scrollTopBtn.addEventListener('click', function() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });





    // Align on load
    window.addEventListener('load', alignFloatingMenuToHeader);

    // Align on resize
    window.addEventListener('resize', alignFloatingMenuToHeader);


    // on page load and after alignment display flex the floating menu



});